function InitialsAvatar({ firstName, lastName }) {
  const firstInitial = firstName ? firstName[0].toUpperCase() : "";
  const lastInitial = lastName ? lastName[0].toUpperCase() : "";

  const initials = firstInitial + lastInitial || "N/A";

  return (
    <div className="size-10 flex items-center justify-center rounded-full bg-[#daeef1] text-secondary">
      <span className="font-semibold">{initials}</span>
    </div>
  );
}

export default InitialsAvatar;
